import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {LoadingService} from "./shared/core/services/loader/loading.service";
import {MessagingService} from "./shared/core/services/all-modules-services/messaging.service";
import {ToastrService} from "ngx-toastr";
import {ConfigService} from "./shared/core/services/all-modules-services/config.service";
import {Title} from "@angular/platform-browser";
import {EnvironmentService} from "./shared/core/services/all-modules-services/environment.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  title = 'Wacni ';
  isLoading$ = this.loaderService.loading$;
  loadingMessage$ = this.loaderService.message$;

  deferredPrompt: any;
  showInstallButton = false;


  constructor(private translate: TranslateService,
              private loaderService: LoadingService,
              private messagingService: MessagingService,
              private toastr: ToastrService,
              private env: EnvironmentService,
              private titleService: Title) {
    // Set default language and restore saved language
    const savedLang = localStorage.getItem('lang') ?? 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(savedLang);
    this.titleService.setTitle(this.env.getTitle());

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallButton = true;
      setTimeout(() => {
        this.showInstallButton = false;
      }, 10000); // 30 seconds
    });
  }

  ngOnInit() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
          .then(reg => {
            console.log('✅ SW registered:', reg);
          })
          .catch(err => {
            console.error('❌ SW registration failed:', err);
          });
    }
    this.messagingService.requestPermission();
    this.messagingService.currentMessage.subscribe( msg => {
      if (msg) {
        this.toastr.success(msg.notification?.body, msg.notification?.title);
        // Show native OS notification when app is in foreground
        if (Notification.permission === 'granted' && navigator.serviceWorker?.controller) {
          navigator.serviceWorker.ready.then(reg => {
            reg.showNotification(msg.notification?.title || 'Notification', {
              body: msg.notification?.body,
              icon: '/assets/icons/icon-192x192.png'
            });
          });
        } else if (Notification.permission === 'granted') {
          new Notification(msg.notification?.title || 'Notification', {
            body: msg.notification?.body,
            icon: '/assets/icons/icon-192x192.png'
          });
        }
      }
    })
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
  }

  installApp() {
    this.showInstallButton = false;
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        this.deferredPrompt = null;
      });
    }
  }
}
